export const closeMenu = () => {
  const closeMenuEvent = new CustomEvent('closemenu');

  window.dispatchEvent(closeMenuEvent);
};

export const openMenu = () => {
  const customEvent = new CustomEvent('openmenu');

  window.dispatchEvent(customEvent);
};

export const toggleMenu = () => {
  const customEvent = new CustomEvent('togglemenu');

  window.dispatchEvent(customEvent);
};
